<mat-progress-spinner *ngIf="isProgressVisible" mode="indeterminate" color="accent">
</mat-progress-spinner>
<div *ngIf="isProgressVisible" class="cdk-overlay-backdrop cdk-overlay-dark-backdrop cdk-overlay-backdrop-showing overlay"></div>
